<template>
  <div class="econ-esg"></div>
</template>

<script setup lang="ts">
import { onMounted } from "vue"

onMounted(() => {
  setTimeout(() => {
    history.go(-1)
  }, 400)
  window.open(`/sov-esg/index.html${window.location.search}`, "_blank")
})
</script>
